import { createAction } from 'redux-act';

import * as notifications from '../../core/notifications';

export const fetchUnreadNotifications = createAction(
  'get unread notifications',
);
export const fetchUnreadNotificationsSuccess = createAction(
  'get unread notifications success',
  (unreadNotifications) => unreadNotifications
);
export const fetchUnreadNotificationsFail = createAction(
  'get unread notifications fail',
  (error) => error
);

export const changeActiveNotification = createAction(
  'change active notification',
);

export const newNotificationReceived = createAction(
  'new notification received',
);

export const markNotificationAsRead = createAction(
  'mark notification as read',
);
export const markNotificationAsReadSuccess = createAction(
  'mark notification as read success',
);
export const markNotificationAsReadFail = createAction(
  'mark notification as read fail',
  (error) => error
);

export const reducer = {
  [fetchUnreadNotificationsSuccess]: (state, payload) =>
    notifications.fetchUnreadNotificationsSuccess(state, payload),

  [changeActiveNotification]: (state, payload) =>
    notifications.changeActiveNotification(state, payload),

  [newNotificationReceived]: (state, payload) =>
    notifications.newNotificationReceived(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/notifications.module.js
 **/